'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VersionMessage = require('./components/VersionMessage.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_VersionMessage).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/version-message/lib/index.js
// module id = 1571
// module chunks = 1